import PropTypes from 'prop-types';
import BrickTile from './BrickTile';

const LandscapeImage = ({ guideItem, index, isExtendedInfoEnabled }) => (
  <BrickTile
    index={index}
    guideItem={guideItem}
    isExtendedInfoEnabled={isExtendedInfoEnabled}
    isLandscapeImage
  />
);

LandscapeImage.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isExtendedInfoEnabled: PropTypes.bool,
};

export default LandscapeImage;
